import { useEffect, useState } from 'react';
import homeIcon from '@/assets/menu/home.png';
import projectIcon from '@/assets/menu/project.png';
import settingIcon from '@/assets/menu/setting.png';
import tutorialIcon from '@/assets/menu/tutorial.png';

import './Navigation.less';
import { useLocation, useNavigate } from 'react-router-dom';
import { reportData } from '@/utils/trackingPoint';
import { useTranslation } from 'react-i18next';
export default function Dashboard() {
  const location = useLocation();
  const { t } = useTranslation();

  const [menus, setMenus] = useState([
    {
      name: 'Home',
      icon: homeIcon,
      path: '/',
    },
    {
      name: 'Project',
      icon: projectIcon,
      path: '/project',
    },
    {
      name: 'Settings',
      icon: settingIcon,
      path: '/setting',
    },
    // {
    //   name: 'Tutorial',
    //   icon: tutorialIcon,
    //   path: '/tutorial',
    // },
  ]);
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMenu(menus.find((item) => location.pathname === item.path) || menus[0]);
  }, [location]);
  const clickMenu = (item) => {
    setActiveMenu(item);
    if (item.name === 'Home') {
      reportData('nav-home');
    } else if (item.name === 'Project') {
      reportData('nav-project');
    } else if (item.name === 'Settings') {
      reportData('nav-setting');
    }
    navigate(item.path);
  };

  return (
    <div className="navigation">
      {menus.map((item) => {
        return (
          <div
            onClick={() => {
              clickMenu(item);
            }}
            className={'menu-item ' + (activeMenu === item ? 'active' : '')}
            key={item.name}>
            <img className="icon" src={item.icon}></img>
            <span className="name">{t(`app.${item.name.toLowerCase()}`)}</span>
          </div>
        );
      })}
    </div>
  );
}
